/**
 * Runs when the New Project wizard is saved with a dataset chosen in the
 * Import step: the dataset's items become the project's tasks. Kept free of
 * imports so the package entry can use it.
 */
export const bringDataset = async ({ project, state, api }: any) => {
  if (!state?.dataset) return { ok: true };
  const said = (res: any, fallback: string) => {
    const errors = res?.response?.validation_errors;
    const flat = Array.isArray(errors) ? errors : errors ? Object.values(errors).flat() : [];
    return (flat.find((e: unknown) => typeof e === "string") as string) ?? res?.response?.detail ?? fallback;
  };
  const listed = (items: string[]) =>
    items.length < 2 ? items.join("") : `${items.slice(0, -1).join(", ")} and ${items[items.length - 1]}`;
  const params = { pk: project.id };
  const plan = await api.callApi("reusePlan", { params, body: { dataset: state.dataset }, errorFilter: () => true });
  if (!plan || plan.error) return { ok: false, message: said(plan, "The dataset could not be read.") };
  if (plan.lacking?.length) {
    return {
      ok: false,
      message: `The labeling setup shows ${listed(plan.lacking)}, which the dataset does not have. Change the setup, then save again.`,
    };
  }
  const res = await api.callApi("reuseBring", { params, body: { dataset: state.dataset }, errorFilter: () => true });
  if (!res || res.error) return { ok: false, message: said(res, "The dataset could not be brought in.") };
  return { ok: true };
};
